import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { databaseKey } from "../common/database_key";
import { fetchBlogData } from "./fetch_blog_data";

const VedicMath = () => {
  const [vedicMathData, setVedicMathData] = useState();
  const collectionName = databaseKey();

  useEffect(() => {
    const fetchVedicMathData = async () => {
      const data = await fetchBlogData(`${collectionName}/vedic-math/`);
      setVedicMathData(data);
    };

    fetchVedicMathData();
  }, [collectionName]);

  return (
    <>
      <div className="blog-container">
        <div className="container">
          {vedicMathData ? (
            <div className="row">
              {vedicMathData.map((blog) => (
                <div key={blog.id} className="card">
                  <Link
                    to={`/readers/vedic-math/${blog.id}`}
                    className="link-style"
                  >
                    <img
                      src={blog.image}
                      className="card-img-top"
                      alt={blog.title}
                    />
                    <div className="card-body">
                      <p className="card-title">
                        <strong>{blog.title}</strong>
                      </p>
                    </div>
                  </Link>
                </div>
              ))}
            </div>
          ) : (
            <>
              <h1 style={{ display: "flex", justifyContent: "center" }}>
                Loading...
              </h1>{" "}
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default VedicMath;
